import { BaseWorkflowActivityAssignmentViewModel } from "../base-workflow-activity-assignment";
import { autoinject } from "aurelia-framework";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { I18N } from "aurelia-i18n";
import { WorkflowAssignmentsService } from "../../../../services/workflow/workflow-assignments-service";
import { UserClaimsService } from "../../../../services/authentication/user-claims.service";
import { RightShipWorkflowStateEnum } from "../../../../models/workflow/rightship.workflow.models";
import { VettingService } from "../../../../services/vetting/vetting.service";

@autoinject()
export class ActivityAssignment extends BaseWorkflowActivityAssignmentViewModel {

    public isCancelled: boolean;

    constructor(
        protected dialogClientService: DialogClientService,
        protected i18N: I18N,
        protected userClaimsService: UserClaimsService,
        protected workflowAssignmentsService: WorkflowAssignmentsService, vetClientService: VettingService) {
        super(dialogClientService, i18N, workflowAssignmentsService, vetClientService);
    }

    onActivated() {
        this.assignment.assignmentState.showStatus = false;
        this.assignment.assignmentState.isSystemAssignment = true;

        let meta: { isSuccess: boolean } = null;

        if (this.assignment.meta) {
            meta = JSON.parse(this.assignment.meta);
        }
        this.assignment.assignmentState.actionTakerAnonText = "RightShip Automation";
        this.assignment.assignmentState.classList = meta && !meta.isSuccess ? 'has-errors' : '';
        this.isCancelled = this.isLastClosedAssignment && this.workflowState.state == RightShipWorkflowStateEnum.Cancelled;

        if (this.assignment.isCurrentAssignment) {
            this.workflowAssignmentsService.executeAction(this.assignment.workflowStateId,
                'onboarding-rules-check-activity',
                'move-next-step',
                this.assignment.workflowAssignmentId,
                null,
                this.assignment.remarks,
                this.assignment.meta).then(response => {
                    this.reload(response.workflowState, response.canTakeOwnership, response.canReassign);
                });
        }
    }
}